import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { convertObjectToQuery, getTenantDetails } from 'utils/utils';
import {
  getWorkFlowAutomationRestartInstance,
  getWorkFlowAutomationRuleDetails,
} from 'services/workflowAutomation/workflowAutomationRuleServices';

export default function useStoppedInstance() {
  const { automationId } = useParams();
  const [automationData, setAutomationData] = useState(null);

  const getAutomationData = () => {
    const [tenantId] = getTenantDetails();
    const automationRulePk = `${tenantId}#${automationId}`;
    const automationRuleSk = `automation_rule#${automationId}`;
    getWorkFlowAutomationRuleDetails(automationRulePk, automationRuleSk)
      .then((res) => {
        setAutomationData(res?.data);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  useEffect(() => {
    automationId && getAutomationData();
  }, [automationId]);

  const restartAutomationInstance = (payload) => {
    return getWorkFlowAutomationRestartInstance(convertObjectToQuery(payload));
  };

  return {
    automationData,
    restartAutomationInstance,
  };
}
